/**
 * Represents a client-side validation error (400 Bad Request).
 * Used for cases where the client sends invalid data that fails validation
 * before making any HTTP requests.
 */
export class BadRequestError extends Error {
  public readonly status = 400;

  constructor(
    message: string,
    public readonly details?: Record<string, unknown>,
  ) {
    super(message);
    this.name = 'BadRequestError';
    Object.setPrototypeOf(this, new.target.prototype);
  }
}
